<div class="container">
    <span class="item-scheduler">{{item.schedulerStr}}</span>
    <span class="tips" kendoTooltip [title]="item.scheduler.configuration" *ngIf="showTimezone">
        <smart-icon name="info-o"></smart-icon>
    </span>
</div>